import { CoreMenu } from 'src/@core/types';

export const movementDiaryMenu: CoreMenu[] = [
  {
    id: 'movement-diary-dashboard',
    title: 'Dashboard',
    type: 'item',
    icon: 'movement-dashboard.svg',
    url: 'movement-diary/dashboard',
    role: {
      roles: ['employee'],
      right: 'Q1000',
    },
  },
  {
    id: 'movement-diary-diary',
    title: 'Movement Diary',
    type: 'item',
    icon: 'movement-diary.svg',
    url: 'movement-diary/diary',
    role: {
      roles: ['employee'],
      right: 'Q1005',
    },
  },
  {
    id: 'movement-diary-schedule',
    title: 'Schedule',
    type: 'item',
    icon: 'schedule.svg',
    url: 'movement-diary/schedule',
    role: {
      roles: ['employee'],
      right: 'Q1014',
    },
  },
  {
    id: 'movement-diary-reports',
    title: 'Reports',
    type: 'item',
    icon: 'reports.svg',
    url: 'movement-diary/reports',
    role: {
      roles: ['employee'],
      right: 'Q1034',
    },
  },
];
